/*=============================================== ContainerPage ===============================================*/

import { Link } from "react-router-dom"
import { Text } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

const ContainerPage = () => {
    const items: ItemType[] = [
        {
            title: "Main",
            content: (
                <Text>
                    <Link
                        to="/layouts/container/demo-main"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here.
                    </Link>
                </Text>
            ),
            code: "<Wrapper>\n    <Main>\n        \n    </Main>\n</Wrapper>",
        },
        {
            title: "Main large",
            content: (
                <Text>
                    <Link
                        to="/layouts/container/demo-main-large"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here.
                    </Link>
                </Text>
            ),
            code: '<Wrapper>\n    <Main size="large">\n        \n    </Main>\n</Wrapper>',
        },
        {
            title: "Main form",
            content: (
                <Text>
                    <Link
                        to="/layouts/container/demo-main-form"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here.
                    </Link>
                </Text>
            ),
            code: '<Wrapper>\n    <Main size="form">\n        \n    </Main>\n</Wrapper>',
        },
        {
            title: "Main full width",
            intro: (
                <>
                    Here, we don't want the <code>Wrapper</code> component
                    around. Use it only when you need the{" "}
                    <Link to="/layouts/full-bleed">FullBleed</Link> component.
                </>
            ),
            content: (
                <Text>
                    <Link
                        to="/layouts/container/demo-main-full"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here.
                    </Link>
                </Text>
            ),
            code: '<Main size="full" gap="xl">\n    \n</Main>',
        },
        {
            title: "Aside left",
            content: (
                <Text>
                    <Link
                        to="/layouts/container/demo-aside-left"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here.
                    </Link>
                </Text>
            ),
            code: '<Wrapper template="2cols">\n    <Aside position={1}>\n        \n    </Aside>\n\n    <Main position={2}>\n        \n    </Main>\n</Wrapper>',
        },
        {
            title: "Aside right",
            content: (
                <Text>
                    <Link
                        to="/layouts/container/demo-aside-right"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here.
                    </Link>
                </Text>
            ),
            code: '<Wrapper template="2cols">\n    <Main position={1}>\n        \n    </Main>\n\n    <Aside position={2}>\n        \n    </Aside>\n</Wrapper>',
        },
        {
            title: "Aside both sides",
            content: (
                <Text>
                    <Link
                        to="/layouts/container/demo-aside-both-sides"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here.
                    </Link>
                </Text>
            ),
            code: '<Wrapper template="3cols">\n    <Aside position={1} size="small">\n        \n    </Aside>\n\n    <Main position={2} size="form">\n        \n    </Main>\n\n    <Aside position={3} size="small">\n        \n    </Aside>\n</Wrapper>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            title: "Wrapper",
            subtitle: "as",
            type: "string",
            possibleString: "Any HTML tag",
            default: "div",
        },
        "separator",
        {
            title: "Main",
            subtitle: "minHeight",
            type: "string or number",
            default: "100vh",
        },
        {
            subtitle: "size",
            type: "string or number",
            possible: ["default", "large", "form", "any number"],
            default: "default",
        },
        {
            subtitle: "contentSize",
            intro: (
                <>
                    Only if <code>size</code> is <code>full</code>
                </>
            ),
            type: "string or number",
            possible: ["default", "large", "form", "any number"],
            default: "default",
        },
        {
            subtitle: "as",
            type: "string",
            possibleString: "Any HTML tag",
            default: "main",
        },
        "separator",
        {
            title: "Aside",
            subtitle: "size",
            type: "string or number",
            possible: ["default", "small", "any number"],
            default: "default",
        },
        {
            subtitle: "minHeight",
            type: "string or number",
            default: "100vh",
        },
        {
            subtitle: "as",
            type: "string",
            possibleString: "Any HTML tag",
            default: "aside",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default ContainerPage
